/**
 * The workspace this device last opened (`localStorage["minga:lastWorkspace"]`, earlier settings spec D2). Only the
 * workspace route's `beforeLoad` writes it; the resolver at `/` reads it. Every storage access may throw (private
 * mode, blocked storage), so each is wrapped.
 */
const KEY = "minga:lastWorkspace"

export const readLastWorkspace = (): string | null => {
  try {
    return globalThis.localStorage?.getItem(KEY) ?? null
  } catch {
    return null
  }
}

export const writeLastWorkspace = (id: string): void => {
  try {
    globalThis.localStorage?.setItem(KEY, id)
  } catch {
    // storage unavailable: the session's activeOrganizationId still covers it
  }
}

export const clearLastWorkspace = (id?: string): void => {
  try {
    if (id === undefined || globalThis.localStorage?.getItem(KEY) === id)
      globalThis.localStorage?.removeItem(KEY)
  } catch {
    // ignore
  }
}

/**
 * Which workspace `/` opens (earlier spec §1.1): the session's active one, else this device's last one, else the most
 * recently joined. Null with no workspaces (→ /welcome).
 */
export const pickWorkspace = (
  list: {
    readonly workspaces: ReadonlyArray<{ readonly id: string; readonly joinedAt: number }>
    readonly activeWorkspaceId: string | null
  },
  last: string | null,
): string | null => {
  if (list.workspaces.length === 0) return null
  const ids = new Set(list.workspaces.map((w) => w.id))
  const known = [list.activeWorkspaceId, last].find((id): id is string => id !== null && ids.has(id))
  if (known) return known
  return [...list.workspaces].sort((a, b) => b.joinedAt - a.joinedAt)[0]?.id ?? null
}

/** Per-workspace "hide the setup checklist" flag (home). */
export const readFlag = (key: string): boolean => {
  try {
    return globalThis.localStorage?.getItem(key) === "1"
  } catch {
    return false
  }
}
export const writeFlag = (key: string, on: boolean): void => {
  try {
    if (on) globalThis.localStorage?.setItem(key, "1")
    else globalThis.localStorage?.removeItem(key)
  } catch {
    // ignore
  }
}
